<template>
    <div>
        <div @click="getRegions()">
            <span class="EBSButton" @click="modal1 = true">+</span>
        </div>
       <Modal v-model="modal1" title="添加存储" @on-ok="handleSubmit('ElasticBlockStoreForm')" @on-cancel="handleReset('ElasticBlockStoreForm')" :loading="modalLoading" ok-text="添加" :mask-closable="false">
            <Form :model="ElasticBlockStoreForm" :label-width="80" ref="ElasticBlockStoreForm" :rules="ruleValidate">

                <Row>
                    <!-- 选择存储容量 -->
                    <Col span="14" style="z-index:100;">
                        <FormItem label="存储容量" prop="storage" :label-width="150">
                            <!-- 存储容量  数据改变时触发-->
                            <Input v-model="ElasticBlockStoreForm.storage" number style="width:200px;" @on-change="storageNum()"></Input>
                        </FormItem>
                    </Col>
                    <!-- 选择单位 -->
                    <Col span="7" style="z-index:50;">
                        <FormItem prop="unit">
                            <Select v-model="ElasticBlockStoreForm.unit" style="width:85px;" @on-change="findUnit(ElasticBlockStoreForm.unit)">
                                <Option :value="item.unit" v-for="item in unitList" v-bind:key="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <div v-if="ElasticBlockStoreForm.category==1">
                    <FormItem label="预配置的IOPS数量" prop="IOPSAmount" :label-width="150" style="margin-top: -21px;">   
                        <!-- 预配置的IOPS数量  数据改变时触发 -->
                        <Input v-model="ElasticBlockStoreForm.IOPSAmount" number style="width: 200px;margin-right: 15px;" @on-change="IOPSAmountNum()"></Input>IOPS
                    </FormItem>
                </div>

                <!-- 选择服务类型 -->
                <FormItem label="服务类型" prop="storageType" :label-width="150">
                    <Select v-model="ElasticBlockStoreForm.storageType" style="width:200px;" @on-change="findStorageType(ElasticBlockStoreForm.storageType)">
                        <Option :value="item.storageType" v-for="item in storageTypeList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                
                
                <!-- 选择存储类型 -->
                <FormItem label="存储类型" prop="category" :label-width="150">
                    <Select v-model="ElasticBlockStoreForm.category" style="width:200px;" @on-change="findCategory(ElasticBlockStoreForm.category)">
                        <Option :value="item.categoryType" v-for="item in categoryList" v-bind:key="item.id" v-show="item.showCategory">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 地区 -->
                <FormItem label="区域" :label-width="150">
                    <Input disabled v-model="regionEBSDate" style="width:200px;"></Input>
                </FormItem>
                
                <!-- 价格 -->
                <FormItem label="价格" :label-width="150">
                    <!-- 北京 -->
                    <div v-show="placeBeijing">￥{{priceBeijing}} / 月 </div>
                    <!-- 新加坡 -->
                    <div v-show="placeSingapore">${{priceSingapore}} / 月 </div>
                </FormItem>                
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: 'AddElasticBlockStore',
        props:['regionEBSDate'],
        data (){
            return {
                isIops:false,
                modal1:false,
                modalLoading: true,
                placeBeijing:true,
                placeSingapore:true,
                priceBeijing: 0.00,
                priceSingapore: 0.00,
                region: '',
                categorys:'',
                regions:'',
                ElasticBlockStoreForm: {
                    category:'0',
                    storage:'',
                    unit: '0',
                    IOPSAmount: '',
                    storageType:'0'
                },
                unitList: [{
                  id: 1,
                  name: 'GB',
                  unit: '0'
                }, {
                    id: 2,
                    name: 'TB',
                    unit: '1'
                }],
                categoryList: [{
                    id: 0,
                    name: '通用型(SSD)卷',
                    categoryType: '0',
                    showCategory:true,
                },{
                    id: 1,
                    name: '预配置IOPS(SSD)卷',
                    categoryType: '1',
                    showCategory:true,
                },{
                    id: 2,
                    name: '吞吐量优化型(HDD)卷',
                    categoryType: '2',
                    showCategory: true
                },{
                    id: 3,
                    name: 'Cold HDD卷',
                    categoryType: '3',
                    showCategory: true
                },{
                    id: 4,
                    name: 'EBS快照',
                    categoryType: '4',
                    showCategory: true
                }],
                storageTypeList: [{
                    id: 0,
                    name: 'EBS',
                    storageType: '0'
                },{
                    id: 1,
                    name: 'RDS',
                    storageType: '1'
                }],
                ruleValidate: {
                    category: [
                        { required: true, message: '请选择存储类型', trigger: 'change' }
                    ],
                    storageType: [
                        { required: true, message: '请选择服务类型', trigger: 'change' }
                    ],
                    storage: [
                        { required: true, message: '请输入数字', trigger: 'blur',type: 'number' }
                    ],
                    unit: [
                        { required: true, message: '请选择单位', trigger: 'change' }
                    ],
                    IOPSAmount: [
                        { required: true, message: '请输入数字', trigger: 'blur',type:'number' }
                    ]
                }
            }
        },
        methods: {
            getStorage:function(){
                var storage;
                if(this.ElasticBlockStoreForm.storage==''){
                    storage=0;
                }else{
                    storage=this.ElasticBlockStoreForm.storage;
                }
                return storage;
            },
            getIOPSAmount:function(){
                var IOPSAmount;
                //如果我是iops并且iops为空，就跳
                if(this.ElasticBlockStoreForm.IOPSAmount==''){
                    IOPSAmount=0;
                }else{
                    IOPSAmount=this.ElasticBlockStoreForm.IOPSAmount;
                }      
                return IOPSAmount;
            },
            getRegions: function(){
                if(this.regionEBSDate=='北京'){
                    this.region='CN_NORTH_1';
                    this.placeBeijing=true;
                    this.placeSingapore=false;
                }else if(this.regionEBSDate=='新加坡'){
                    this.region='AP_SOUTHEAST_1';
                    this.placeSingapore=true;
                    this.placeBeijing=false;
                }
            },
            // 查询当前EBS价格
            getStoragePrice:function(){
                this.$api.price.getStoragePrice({
                    "category": this.ElasticBlockStoreForm.category,
                    "storage": this.getStorage(),
                    "number": 1,
                    "iops": this.getIOPSAmount(),
                    "region": this.region,
                    "unit":this.ElasticBlockStoreForm.unit,
                    "storageType": this.ElasticBlockStoreForm.storageType
                })
                .then(res => {
                    //北京
                    this.priceBeijing=res.data.monthlyCostByRMB.toFixed(2);
                    //新加坡
                    this.priceSingapore=res.data.monthlyCostByDollars.toFixed(2);
                    //容量
                    this.categorys=res.data.category;
                    //区域
                    this.regions=res.data.region;
                })
            },
            // 存储容量方法
            storageNum: function(){
                this.getStoragePrice();
            },
            // 预配置的IOPS数量方法
            IOPSAmountNum: function(){
                this.getStoragePrice();
            },
            // 单位方法
            findUnit: function(){
                this.getStoragePrice();
            },
            // 服务类型
            findStorageType:function(){
                //还原默认值
                this.ElasticBlockStoreForm.category="0";
                // 服务类型为RDS
                if(this.ElasticBlockStoreForm.storageType==1){
                    for(var i=0;i<this.categoryList.length;i++){
                        this.categoryList[0].showCategory=true;
                        this.categoryList[1].showCategory=true;
                        this.categoryList[2].showCategory=false;
                        this.categoryList[3].showCategory=false;
                        this.categoryList[4].showCategory=false;
                    }
                }
                // 服务类型为EBS
                else if(this.ElasticBlockStoreForm.storageType==0){
                    for(var i=0;i<this.categoryList.length;i++){
                        this.categoryList[0].showCategory=true;
                        this.categoryList[1].showCategory=true;
                        this.categoryList[2].showCategory=true;
                        this.categoryList[3].showCategory=true;
                        this.categoryList[4].showCategory=true;
                    }
                }
                this.getStoragePrice();
            },
            // 存储类型方法
            findCategory: function(){          
                if(this.ElasticBlockStoreForm.category==1){
                    if(this.ElasticBlockStoreForm.IOPSAmount==''||this.ElasticBlockStoreForm.storage==''){
                        return;
                    }
                    this.getStoragePrice();
                }else{
                    this.ElasticBlockStoreForm.IOPSAmount='';
                    if(this.ElasticBlockStoreForm.storage==''){
                        return;
                    }
                    // 查询当前EBS价格
                    this.$api.price.getStoragePrice({
                        "category": this.ElasticBlockStoreForm.category,
                        "storage": this.getStorage(),
                        "number": 1,
                        "region": this.region,
                        "unit":this.ElasticBlockStoreForm.unit,
                        "storageType": this.ElasticBlockStoreForm.storageType
                    })
                    .then(res => {
                        //北京
                        this.priceBeijing=res.data.monthlyCostByRMB.toFixed(2);
                        //新加坡
                        this.priceSingapore=res.data.monthlyCostByDollars.toFixed(2);
                        //容量
                        this.categorys=res.data.category;
                        //区域
                        this.regions=res.data.region;
                    })
                }
                
            },
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid&&(this.priceBeijing!=0 || this.priceSingapore!=0)) {
                        var EBSListCopy=new Object();
                        EBSListCopy.region=this.regionEBSDate;
                        EBSListCopy.category=this.ElasticBlockStoreForm.category;
                        EBSListCopy.storage=this.ElasticBlockStoreForm.storage;
                        EBSListCopy.iops=this.ElasticBlockStoreForm.IOPSAmount;
                        EBSListCopy.unit=this.ElasticBlockStoreForm.unit;
                        EBSListCopy.storageType=this.ElasticBlockStoreForm.storageType;
                        EBSListCopy.number=1;
                        EBSListCopy.month=1;
                        EBSListCopy.usage='';
                        EBSListCopy.categorys=this.categorys;
                        EBSListCopy.regions=this.regions;
                        EBSListCopy.priceBeijing=this.priceBeijing;
                        EBSListCopy.priceSingapore=this.priceSingapore;
                        // 传值
                        this.$emit('addEBSCallBack',EBSListCopy);
                        setTimeout(() => {
                            this.modalLoading = false;
                            this.$nextTick(() => {
                                this.modalLoading = true;
                            });
                            this.ElasticBlockStoreForm.storage="";
                            this.ElasticBlockStoreForm.IOPSAmount="";
                            this.priceBeijing=0.00;
                            this.priceSingapore=0.00;                        
                            this.$Message.success('添加成功');    
                            this.modal1 = false;
                        },1000);                  
                    }                     
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.modalLoading = false;
                        setTimeout(() => {
                            this.modalLoading = true
                        }, 0)
                    }
                });
            },
            handleReset: function(name) {
                this.priceBeijing=0.00;
                this.priceSingapore=0.00;
                this.ElasticBlockStoreForm.storage="";
                this.ElasticBlockStoreForm.IOPSAmount="";
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped>
    .EBSButton
    {
        float: right;
        width: 25px;
        height: 25px;
        border-radius: 50%;
        display: block;
        background-color: #2db7f5;
        text-align: center;
        line-height: 25px;
        color: #fff;
        font-size: 19px;
        margin-top: 7px;
        margin-right: 10px;
        cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/ebilling/cost_calculation/AddElasticBlockStore.vue